import { useEffect } from 'react';
import { getExamInputs } from '../../../services/exam';
export const useSharedInputs = ({
  fromExternal,
  consultationExamsData,
  setConsultationExamsData,
  consultationServices,
  admissionPatientId,
  isGroupedExams,
  allExams,
  inputs,
  form,
  from
}) => {
  useEffect(() => {
    if (!(fromExternal && from === 'consultation') || !admissionPatientId) return;

    const processSharedInputs = async () => {
      const examsToCheck = isGroupedExams ? allExams : [inputs];
      const newFormValues = { procedures: {}, measurements: {}, questions: {} };
      let updatedExamsData = [...consultationExamsData];
      let hasGlobalChanges = false;

      for (const exam of examsToCheck) {
        const sharedInputs = exam?.extra_data_exam?.shared_inputs;
        if (!sharedInputs) continue;

        for (const [sourceExamId, mappings] of Object.entries(sharedInputs)) {
          const parsedId = parseInt(sourceExamId);
          let sourceExamData = updatedExamsData.find(data =>
            data.id === parsedId || data.inputs?.id === parsedId
          );
          if (!sourceExamData && consultationServices) {
            const service = consultationServices.find(s => s.exam_id === parsedId);
            if (!service) continue;

            const response = await getExamInputs({
              admissionPatientExamId: service.admission_patient_exam_id
            });
            sourceExamData = { id: parsedId, inputs: response };
            updatedExamsData.push(sourceExamData);
          }

          if (!sourceExamData?.inputs) continue;

          mappings.forEach(({ source_code, target_code, type }) => {
            const sourceResult = sourceExamData.inputs[type]?.find(r => r.code === source_code)?.result;
            const targetField = exam[type]?.find(field => field.code === target_code);
            if (targetField && sourceResult != null && sourceResult !== '' && !form.getFieldValue([type, targetField.id.toString()])) {
              newFormValues[type][targetField.id.toString()] = sourceResult;
              hasGlobalChanges = true;
            }
          });
        }
      }

      if (updatedExamsData.length > consultationExamsData.length) {
        setConsultationExamsData(updatedExamsData);
      }
      if (hasGlobalChanges) {
        form.setFieldsValue(newFormValues);
      }
    };

    processSharedInputs();
  }, [fromExternal, admissionPatientId, isGroupedExams, allExams, inputs, form, consultationExamsData, consultationServices, setConsultationExamsData]);
};